<template>
  <div>
    <Header />

    <!-- 毛毛蟲 -->
    <nav aria-label="breadcrumb" class="breadcrumb_box">
      <div class="container">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Profile" title="Home">Home</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Profile</li>
        </ol>
      </div>
    </nav>

    

    <div class="main form profile_box">
      <a accesskey="c" class="accesskey" id="accesskey_c" href="javascript:void(0);" title="中央內容區塊"
        onclick="document.getElementById('accesskey_c').scrollIntoView();">
        :::
      </a>
      <div class="container">
        <div class="box">
          <div class="title">
            <h2>Profile</h2>
          </div>
          <ul class="tab_box">
            <li v-for="tab in tabs" :key="tab">
              <button :class="['tab_btn', { active: activeTab === tab }]" @click="activeTab = tab">
                <p>{{ tab }}</p>
                <div class="line"></div>
              </button>
            </li>
          </ul>
          <div class="tab_content">
            <!-- 載入中 -->
            <div class="bg information_box" v-if="isLoadingApplication && activeTab === 'Basic Information'">
              <div class="title_box">
                <h3>Loading...</h3>
              </div>
            </div>

            <!-- 沒有申請資料的狀態 -->
            <div class="bg information_box"
              v-else-if="(!hasApplication || !isReview || isAgree != 1) && activeTab === 'Basic Information'">
              <div class="title_box">
                <h3>Application Status</h3>
              </div>
              <div class="text_box start_box">
                <!-- 有進行中的學期梯次 - 顯示開始申請按鈕 -->
                <div v-if="hasActiveApplyPeriod">
                  <p>You haven't started your application yet.</p>
                  <div class="btn_box">
                    <button class="btn" @click="handleStartApplication">
                      Start Application
                    </button>
                  </div>
                </div>
                <!-- 沒有進行中的學期梯次 - 顯示訊息 -->
                <div v-else>
                  <p style="font-size: 16px; color: #666;">No active application period available at this time.</p>
                </div>
              </div>
            </div>

            <!-- 基本資料 - 有申請資料時顯示 -->
            <div class="bg information_box" v-else-if="hasApplication && activeTab === 'Basic Information'">
              
              <div class="title_box" v-if="semesterInfo">
                <h3>Application Semester<span>{{ semesterInfo }}</span></h3>
              </div>
              <div class="title_box">
                <h3>Application Number<span>{{ applyID }}</span></h3>
              </div>
              <!-- 基本資料 -->
              <ul class="basic_list">
                <li>
                  <p>Name</p>
                  <p>{{ name }}</p>
                </li>
                <li>
                  <p>Email</p>
                  <p>{{ email }}</p>
                </li>
                <li class="full">
                  <p>Phone</p>
                  <p>{{ phone }}</p>
                </li>
                <li class="full programs_box">
                  <p>Application Programs</p>
                  <ul class="programs">
                    <li v-for="(item, index) in profileProgramsItems" :key="index">
                      <div class="number">{{ index + 1 }}</div>
                      <div>
                        <p>{{ item.college }}</p>
                        <p>{{ item.programs }}</p>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
              <div class="title_box">
                <h3>Application Status Inquiry</h3>
              </div>
              <!-- 申請進度查看 -->
              <ul class="progress_bar">
                <li v-for="(item, index) in progressItems" :key="index">
                  <div :class="['step_box', item.status]">
                    <div class="step">
                      <p v-if="index != 6">Step {{ index + 1 }}</p>
                      <p v-else>Payment</p>
                      <p>
                        {{ item.title }}
                      </p>
                      <!-- 如果有 link 就顯示 router-link -->
                      <router-link class="progress_link" v-if="item.link && item.to" :to="item.to">
                        {{ item.link }}
                      </router-link>
                    </div>
                    <div class="line"></div>
                  </div>
                </li>
              </ul>
              <div class="title_box">
                <h3>Review Result</h3>
              </div>
              <div class="reviewStatus_box">
                <p>Review Status</p>
                <!-- 改變狀態 -->
                <!-- <p :class="statusIcon.class">
                  <img v-if="statusIcon.icon" :src="statusIcon.icon" :alt="statusIcon.label" />
                  {{ statusIcon.label }}
                </p> -->
                <p :style="{ color: hasDocumentsToResubmit ? '#dc3545' : '' }">{{ reviewStatus }}</p>
              </div>
              <!-- 狀態 待補件 顯示pendingDocuments_box的div -->
              <div class="pendingDocuments_box" v-if="hasDocumentsToResubmit">
                
                <!-- 共同文件待補件區塊 -->
                <div class="program bg" v-if="generalFilesNeedResubmit" 
                     :style="{
                       backgroundColor: generalFilesWithResubmit.every(f => f.uploadedFile?.reviewStatus === 5) ? '#d4edda' : '#fff3cd',
                       borderLeft: generalFilesWithResubmit.every(f => f.uploadedFile?.reviewStatus === 5) ? '4px solid #28a745' : '4px solid #ffc107',
                       position: 'relative'
                     }">
                  <div :style="{
                    position: 'absolute',
                    top: '10px',
                    right: '15px',
                    background: generalFilesWithResubmit.every(f => f.uploadedFile?.reviewStatus === 5) ? '#28a745' : '#ffc107',
                    color: generalFilesWithResubmit.every(f => f.uploadedFile?.reviewStatus === 5) ? '#fff' : '#856404',
                    padding: '5px 15px',
                    borderRadius: '4px',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }">
                    {{ generalFilesWithResubmit.every(f => f.uploadedFile?.reviewStatus === 5) ? 'Resubmitted' : 'Documents Required' }}
                  </div>
                  <div class="title">
                    <div class="number">G</div>
                    <div>
                      <p style="font-weight: bold; font-size: 18px;">General Requirements</p>
                    </div>
                  </div>
                  <ul class="file_list">
                    <li v-for="(file, i) in generalFilesWithResubmit" :key="file.afId">
                      <p>
                        <span class="num">{{ i + 1 }}.</span>{{ file.name_EN || file.name }}
                      </p>
                      
                      <!-- 顯示補件原因說明 -->
                      <p class="text" v-if="file.uploadedFile?.reviewInfo" style="color: #dc3545; font-weight: bold; margin-top: 8px; padding: 10px; background-color: #fff; border-left: 3px solid #dc3545; border-radius: 4px;">
                        <strong>Reason:</strong> {{ file.uploadedFile.reviewInfo }}
                      </p>
                      
                      <!-- reviewStatus = 5 表示已補件待審核 -->
                      <p v-if="file.uploadedFile?.reviewStatus === 5" style="color: #28a745; font-weight: bold; margin-top: 10px;">
                        ✓ Resubmitted - Pending Review
                      </p>
                      
                      <!-- reviewStatus = 4 顯示上傳功能 -->
                      <div v-else style="margin-top: 10px;">
                        <input 
                          type="file" 
                          :id="'general-file-' + file.afId" 
                          @change="handleFileResubmit($event, file.afId, 0)"
                          :disabled="uploading"
                          style="display: none;"
                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                        />
                        <label 
                          :for="'general-file-' + file.afId" 
                          class="file_a" 
                          style="background-color: #dc3545; color: #fff; cursor: pointer; display: inline-block;"
                        >
                          {{ uploading ? 'Uploading...' : 'Choose & Upload File' }}
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>

                <!-- 系所文件待補件區塊 -->
                <div class="program bg" v-for="(program, index) in departmentFilesNeedResubmit" :key="program.pId"
                     :style="{
                       backgroundColor: program.files.every(f => f.uploadedFile?.reviewStatus === 5) ? '#d4edda' : '#fff3cd',
                       borderLeft: program.files.every(f => f.uploadedFile?.reviewStatus === 5) ? '4px solid #28a745' : '4px solid #ffc107',
                       position: 'relative',
                       marginTop: '20px'
                     }">
                  <div :style="{
                    position: 'absolute',
                    top: '10px',
                    right: '15px',
                    background: program.files.every(f => f.uploadedFile?.reviewStatus === 5) ? '#28a745' : '#ffc107',
                    color: program.files.every(f => f.uploadedFile?.reviewStatus === 5) ? '#fff' : '#856404',
                    padding: '5px 15px',
                    borderRadius: '4px',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }">
                    {{ program.files.every(f => f.uploadedFile?.reviewStatus === 5) ? 'Resubmitted' : 'Documents Required' }}
                  </div>
                  <div class="title">
                    <div class="number">{{ index + 1 }}</div>
                    <div>
                      <p>{{ program.programInfo.collegeName_EN || program.programInfo.collegeName }}</p>
                      <p>{{ program.programInfo.departmentName_EN || program.programInfo.departmentName }}</p>
                      <p style="font-weight: bold;">{{ program.programInfo.name_EN || program.programInfo.name }}</p>
                    </div>
                  </div>
                  <ul class="file_list">
                    <li v-for="(file, i) in program.files" :key="file.afId">
                      <p>
                        <span class="num">{{ i + 1 }}.</span>{{ file.name_EN || file.name }}
                      </p>
                      
                      <!-- 顯示補件原因說明 -->
                      <p class="text" v-if="file.uploadedFile?.reviewInfo" style="color: #dc3545; font-weight: bold; margin-top: 8px; padding: 10px; background-color: #fff; border-left: 3px solid #dc3545; border-radius: 4px;">
                        <strong>Reason:</strong> {{ file.uploadedFile.reviewInfo }}
                      </p>
                      
                      <!-- reviewStatus = 5 表示已補件待審核 -->
                      <p v-if="file.uploadedFile?.reviewStatus === 5" style="color: #28a745; font-weight: bold; margin-top: 10px;">
                        ✓ Resubmitted - Pending Review
                      </p>
                      
                      <!-- reviewStatus = 4 顯示上傳功能 -->
                      <div v-else style="margin-top: 10px;">
                        <input 
                          type="file" 
                          :id="'dept-file-' + program.pId + '-' + file.afId" 
                          @change="handleFileResubmit($event, file.afId, program.pId)"
                          :disabled="uploading"
                          style="display: none;"
                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                        />
                        <label 
                          :for="'dept-file-' + program.pId + '-' + file.afId" 
                          class="file_a" 
                          style="background-color: #dc3545; color: #fff; cursor: pointer; display: inline-block;"
                        >
                          {{ uploading ? 'Uploading...' : 'Choose & Upload File' }}
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- 資格審查失敗的樣子 -->
            <div class="bg failed_box" v-if="activeTab === 'Basic Information2'">
              <div class="title_box">
                <h3>Failed Eligibility Review</h3>
              </div>
              <div class="text_box">
                <p class="text">
                  Description Test of Chinese as a Foreign Language (TOCFL, Band
                  C/Level 5) or your previous degree in Chinese relevant
                  studyTest of Chinese as a Foreign Language (TOCFL, Band
                  C/Level 5) or your previous degree in Chinese relevant study
                </p>
                <div class="btn_box">
                  <button class="btn" @click="gotoQualificationForm">
                    Reapply
                  </button>
                </div>
              </div>
            </div>
            <!-- 修改密碼 -->
            <div class="bg changePassword_box" v-else-if="activeTab === 'Change Password'">
              <div class="title_box">
                <h3>Change Password</h3>
              </div>
              <div :class="['form-group full', { active: passwordForm.oldPassword }]">
                <input type="password" class="form-control" id="oldPassword" required
                  v-model="passwordForm.oldPassword" />
                <label for="oldPassword"><span class="required">*</span>Current Password</label>
              </div>
              <div :class="['form-group full', { active: passwordForm.newPassword }]">
                <input type="password" class="form-control" id="newPassword" required
                  v-model="passwordForm.newPassword" />
                <label for="newPassword"><span class="required">*</span>New Password</label>
                <p class="notice">
                  *At least 8 characters, with uppercase, lowercase, and a
                  number.
                </p>
              </div>
              <div :class="['form-group full', { active: passwordForm.confirmPassword }]">
                <input type="password" class="form-control" id="confirmPassword" required
                  v-model="passwordForm.confirmPassword" />
                <label for="confirmPassword"><span class="required">*</span>Confirm New Password</label>
              </div>
              <div class="btn_box">
                <button class="btn" @click="handleChangePassword" :disabled="isSubmitting">
                  {{ isSubmitting ? 'Submitting...' : 'Submit' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import authService from '@/services/auth';
import applyStudentService from '@/services/applyStudent';
import validate from '@/utils/validate';
import Swal from 'sweetalert2';
import { uploadSingleFile } from '@/utils/uploadHelper';
import { validateFile } from '@/utils/fileHelper';

import { driver } from "driver.js";

export default {
  name: "Profile",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      // 頁籤切換
      tabs: ["Basic Information", "Change Password"], // 頁籤清單
      activeTab: "Basic Information", // 預設選中的頁籤

      // 基本資料
      applyID: "",
      name: "",
      phone: "",
      email: "",
      semesterInfo: "", // 學期梯次資訊

      // 申請狀態相關
      hasApplication: false, // 是否有填寫過申請資料
      hasActiveApplyPeriod: false, // 是否有進行中的學期梯次
      isLoadingApplication: true, // 載入中狀態
      // 選擇系所 最多四個
      profileProgramsItems: [
        // {
        //   college: "College of Science",
        //   programs: "Department of Materials Science and Engineering",
        // },
        // {
        //   college: "College of Electrical Engineering and Computer Science",
        //   programs:
        //     "Department of Industrial Engineering and EngineeringManagement",
        // },
        // {
        //   college: "College of Electrical Engineering and Computer Science",
        //   programs: "Department of Educational Psychology and Counseling",
        // },
        // {
        //   college: "College of Life Science and Medicine",
        //   programs: "Department of Materials Science and Engineering",
        // },
      ],
      // 進度步驟
      progressItems: [
        {
          title: "Fill out online application form",
          link: "Modify",
          to: "/Apply/1",
          status: "",
        },
        {
          title: "Apply for a program",
          link: "Modify",
          to: "/Apply/2",
          status: "",
        },
        {
          title:
            "Fill out Recommenders (Do Not Fill Out Without Notifying Your Recommenders in Advance.)",
          link: "View Recommendation Status / Change Referee",
          to: "/Apply/3",
          status: "",
        },
        {
          title: "Upload Required Documents 1",
          link: "Upload Documents",
          to: "/Apply/4",
          status: "",
        },
        {
          title: "Upload Required Documents 2",
          link: "Upload Documents",
          to: "/Apply/5",
          status: "",
        },
        {
          title: "Review & Submit",
          link: "Review & Submit Application",
          to: "/Apply/Check",
          status: "",
        },
        {
          title: "Make Payment",
          link: "Payment",
          to: "/Apply/Pay",
          status: "",
        },
      ],
      // 用代碼代表狀態
      reviewStatus: "Applying", //補件中
      // reviewStatus: "approved", //審核通過
      //補件中 顯示出來的內容
      pendingDocumentsItem: [
        // {
        //   college: "College of Electrical Engineering and Computer Science",
        //   programs: "Department of Educational Psychology and Counseling",
        //   fileList: [
        //     {
        //       file: "Test of Chinese as a Foreign Language (TOCFL, Band C/Level 5) or your previous degree in Chinese relevant study",
        //       text: "Description Test of Chinese as a Foreign Language (TOCFL, Band C/Level 5) or your previous degree in Chinese relevant studyTest of Chinese as a Foreign Language (TOCFL, Band C/Level 5) or your previous degree in Chinese relevant study",
        //       link: "",
        //     },
        //     {
        //       file: "Other documents to support your application ( Curriculum Vitae, Thesis Publication, GRE, Honor, Awards, etc. )",
        //       text: "Description",
        //       link: "",
        //     },
        //   ],
        // },
        // {
        //   college: "College of Science",
        //   programs: "Department of Materials Science and Engineering",
        //   fileList: [
        //     {
        //       file: "Other documents to support your application ( Curriculum Vitae, Thesis Publication, GRE, Honor, Awards, etc. )",
        //       text: "Description",
        //       link: "",
        //     },
        //   ],
        // },
      ],

      //讓欄位點選可以移動label動畫
      formData: {},

      // 密碼變更表單
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      },

      // 提交狀態
      isSubmitting: false,

      isReview: false,
      isAgree: 0,

      // 申請表相關 ID
      asId: null, // 申請表 ID
      aId: null, // 學期梯次 ID

      // 待補件資訊
      hasDocumentsToResubmit: false, // 是否有需要補件的檔案
      generalFilesNeedResubmit: false, // 共同文件是否需要補件
      generalFilesWithResubmit: [], // 需要補件的共同文件列表
      departmentFilesNeedResubmit: [], // 需要補件的系所文件列表（按學程分組）

      // 上傳狀態
      uploading: false,
    };
  },

  computed: {
    ...mapGetters(['currentUser', 'isLoggedIn']),

    // 申請狀態改變換icon圖
    statusIcon() {
      const statusMap = {
        approved: {
          label: "Approved",
          icon: "img/icon_done.svg",
          class: "done",
        },
        additional: {
          label: "Additional Documents Required",
          icon: "img/icon_waiting.svg",
          class: "",
        },
      };

      // 回傳對應狀態資料，或預設 fallback
      return (
        statusMap[this.reviewStatus] || {
          label: this.reviewStatus,
          icon: null,
          class: "",
        }
      );
    },
  },

  mounted() {
    window.scrollTo(0, 0);

    // Load user data from store
    // if (this.currentUser) {
    //   this.name = this.currentUser.name || this.currentUser.account;
    //   this.email = this.currentUser.email || '';
    // }

    // 檢查並載入申請資料
    this.checkAndLoadApplicationData();
  },

  methods: {
    ...mapActions(['logout']),

    async checkAndLoadApplicationData() {
      this.isLoadingApplication = true;

      try {
        const activePeriodResult = await applyStudentService.checkActiveApplyPeriod();

        if (activePeriodResult.success && activePeriodResult.data?.hasActiveApply === true) {
          // 1-2-1. 有進行中的學期梯次
          this.hasActiveApplyPeriod = true;
        } else {
          // 1-2-2. 沒有進行中的學期梯次
          this.hasActiveApplyPeriod = false;
        }

        // 1. 檢查是否有填寫過申請資料
        const checkResult = await applyStudentService.checkUserApplication();

        if (checkResult.success && checkResult.data) {
          this.isReview = checkResult.data?.isReview || false;
          this.isAgree = checkResult.data?.isAgree || false;
        }

        if (checkResult.success && checkResult.data?.hasApplication === true) {
          // 1-1. 有申請資料，取得申請資料內容
          this.hasApplication = true;

          const applicationResult = await applyStudentService.getUserApplication();

          if (applicationResult.success && applicationResult.data) {
            const data = applicationResult.data;

            this.asId = data.asId;
            this.aId = data.aId;
            this.applyID = data.applyID || '';
            this.semesterInfo = data.semesterInfo || '';

            // 組合姓名: nameFirst + nameMiddle + nameLast
            const firstName = data.nameFirst || '';
            const middleName = data.nameMiddle || '';
            const lastName = data.nameLast || '';
            this.name = [firstName, middleName, lastName].filter(n => n).join(' ');

            // Email
            this.email = data.contactEmail || '';

            // 組合電話: mailPhoneCountry + mailPhoneArea + mailPhoneNumber
            const phoneCountry = data.mailPhoneCountry || '';
            const phoneArea = data.mailPhoneArea || '';
            const phoneNumber = data.mailPhoneNumber || '';
            this.phone = [phoneCountry, phoneArea, phoneNumber].filter(p => p).join(' ');

            // 申請狀態
            if (data.applyStatus == 0) {
              this.reviewStatus = "Applying";
            } else if (data.applyStatus == 1) {
              // 當 applyStatus = 1 時，載入文件狀態以檢查是否需要補件
              this.reviewStatus = "Sent for Review";
              await this.loadDocumentsResubmitStatus();
            } 
          }
        } else {
          // 1-2. 沒有申請資料
          this.hasApplication = false;
        }
      } catch (error) {
        console.error('Error loading application data:', error);
      } finally {
        this.isLoadingApplication = false;
      }
    },

    async handleStartApplication() {
      try {
        // 先檢查是否有多個學期梯次
        const activePeriodResult = await applyStudentService.checkActiveApplyPeriod();
        
        if (activePeriodResult.success && activePeriodResult.data?.applies) {
          const applies = activePeriodResult.data.applies;
          
          // 如果有多個學期梯次，導向選擇頁面
          if (applies.length > 1) {
            this.$router.push("/SelectSemester").then(() => {
              window.scrollTo(0, 0);
            });
            return;
          }
          
          // 如果只有一個學期梯次，儲存其 aId 並繼續原有流程
          if (applies.length === 1) {
            localStorage.setItem('selectedApplyId', applies[0].aId.toString());
            
            // 清空使用者的同意條款狀態
            await authService.clearReviewAndAgree();
          }
        }

        // 檢查是否有資格審核的步驟
        const eligibilityResult = await applyStudentService.hasActiveApplyEligibility();
        if (eligibilityResult.success && eligibilityResult.data?.hasEligibility === true) {
          if (this.isReview) {
            if (this.isAgree === 1) {
              this.$router.push("/Apply/1").then(() => {
                window.scrollTo(0, 0);
              });
            } else {
              this.$router.push("/Terms").then(() => {
                window.scrollTo(0, 0);
              });
            }
          } else {
            this.$router.push("/QualificationForm").then(() => {
              window.scrollTo(0, 0);
            });
          }
        } else {
          if (this.isAgree === 1) {
            this.$router.push("/Apply/1").then(() => {
              window.scrollTo(0, 0);
            });
          } else {
            this.$router.push("/Terms").then(() => {
              window.scrollTo(0, 0);
            });
          }
        }
      } catch (error) {
        console.error('Error checking eligibility:', error);
        // 發生錯誤時，預設導向 Terms 頁面
        this.$router.push("/Terms").then(() => {
          window.scrollTo(0, 0);
        });
      }
    },

    gotoQualificationForm() {
      this.$router.push("/QualificationForm").then(() => {
        window.scrollTo(0, 0); // 滾到最上面
      });
    },

    /**
     * 處理檔案補件上傳
     */
    async handleFileResubmit(event, afId, pId) {
      const file = event.target.files[0];
      if (!file) return;

      // 驗證檔案
      const validation = validateFile(file, {
        maxSizeMB: 10,
        allowedTypes: ['.pdf', '.jpg', '.jpeg', '.png', '.doc', '.docx']
      });

      if (!validation.valid) {
        await Swal.fire({
          icon: 'error',
          title: 'Invalid File',
          text: validation.message,
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        event.target.value = '';
        return;
      }

      // 上傳檔案
      await this.uploadResubmitFile(file, afId, pId);
      
      // 清空 input 以便可以重新選擇相同檔案
      event.target.value = '';
    },

    /**
     * 上傳補件檔案
     */
    async uploadResubmitFile(file, afId, pId) {
      if (this.uploading) {
        return;
      }

      try {
        this.uploading = true;

        // 使用上傳工具，會自動顯示進度
        const result = await uploadSingleFile({
          asId: this.asId,
          file: file,
          pId: pId, // 通用文件使用 0，系所文件使用實際的 pId
          afId: afId
        });

        // 上傳成功後重新載入補件狀態
        if (result.success && result.successCount > 0) {
          await this.loadDocumentsResubmitStatus();
        }

      } catch (error) {
        console.error('Upload error:', error);
      } finally {
        this.uploading = false;
      }
    },

    /**
     * 載入並檢查文件補件狀態
     */
    async loadDocumentsResubmitStatus() {
      if (!this.asId) return;

      try {
        // 重置狀態
        this.hasDocumentsToResubmit = false;
        this.generalFilesNeedResubmit = false;
        this.generalFilesWithResubmit = [];
        this.departmentFilesNeedResubmit = [];

        // 1. 載入共同文件（Form_4）
        const generalResult = await applyStudentService.getGeneralUploadFiles(this.asId);
        if (generalResult.success && generalResult.data) {
          // reviewStatus = 4 表示需要補件，reviewStatus = 5 表示已補件待審核
          const filesNeedResubmit = generalResult.data.filter(
            file => file.uploadedFile && (file.uploadedFile.reviewStatus === 4 || file.uploadedFile.reviewStatus === 5)
          );
          
          if (filesNeedResubmit.length > 0) {
            this.generalFilesNeedResubmit = true;
            this.generalFilesWithResubmit = filesNeedResubmit;
            // 只有當有 reviewStatus = 4 的檔案時才顯示待補件狀態
            const stillNeedResubmit = filesNeedResubmit.some(f => f.uploadedFile.reviewStatus === 4);
            if (stillNeedResubmit) {
              this.hasDocumentsToResubmit = true;
            }
          }
        }

        // 2. 載入系所文件（Form_5）
        // 先取得申請的學程列表
        const applicationResult = await applyStudentService.getUserApplication();
        if (applicationResult.success && applicationResult.data?.applyPrograms) {
          try {
            const programIds = JSON.parse(applicationResult.data.applyPrograms);
            
            // 載入所有學程資訊
            const programsResult = await applyStudentService.getActiveApplyPrograms(this.aId);
            if (programsResult.success && programsResult.data) {
              const allPrograms = programsResult.data.programs || [];

              // 檢查每個學程的系所文件
              for (const pId of programIds) {
                const program = allPrograms.find(p => p.pId === pId);
                if (!program) continue;

                const deptResult = await applyStudentService.getDepartmentUploadFiles({
                  asId: this.asId,
                  pId: pId
                });

                if (deptResult.success && deptResult.data) {
                  // reviewStatus = 4 表示需要補件，reviewStatus = 5 表示已補件待審核
                  const filesNeedResubmit = deptResult.data.filter(
                    file => file.uploadedFile && (file.uploadedFile.reviewStatus === 4 || file.uploadedFile.reviewStatus === 5)
                  );

                  if (filesNeedResubmit.length > 0) {
                    this.departmentFilesNeedResubmit.push({
                      pId: pId,
                      programInfo: program,
                      files: filesNeedResubmit
                    });
                    // 只有當有 reviewStatus = 4 的檔案時才顯示待補件狀態
                    const stillNeedResubmit = filesNeedResubmit.some(f => f.uploadedFile.reviewStatus === 4);
                    if (stillNeedResubmit) {
                      this.hasDocumentsToResubmit = true;
                    }
                  }
                }
              }
            }
          } catch (error) {
            console.error('Error parsing applyPrograms:', error);
          }
        }

        // 3. 根據是否有待補件更新 reviewStatus 顯示
        if (this.hasDocumentsToResubmit) {
          this.reviewStatus = "Documents Required";
        } else {
          // 檢查是否有任何檔案處於已補件待審核狀態
          const hasResubmittedFiles = 
            this.generalFilesWithResubmit.some(f => f.uploadedFile?.reviewStatus === 5) ||
            this.departmentFilesNeedResubmit.some(p => p.files.some(f => f.uploadedFile?.reviewStatus === 5));
          
          if (hasResubmittedFiles) {
            this.reviewStatus = "Resubmitted - Under Review";
          } else {
            this.reviewStatus = "Under Review";
          }
        }

      } catch (error) {
        console.error('Error loading documents resubmit status:', error);
      }
    },

    handleLogout() {
      if (confirm('Are you sure you want to logout?')) {
        this.logout();
        this.$router.push('/');
      }
    },

    async handleChangePassword() {
      // 驗證所有欄位是否填寫
      if (!this.passwordForm.oldPassword || !this.passwordForm.newPassword || !this.passwordForm.confirmPassword) {
        await Swal.fire({
          icon: 'error',
          title: 'Validation Error',
          text: 'Please fill in all fields',
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        return;
      }

      // 驗證新密碼格式
      if (!validate.reg_password(this.passwordForm.newPassword)) {
        await Swal.fire({
          icon: 'error',
          title: 'Invalid Password Format',
          text: 'New password must be at least 8 characters with uppercase, lowercase, and a number',
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        return;
      }

      // 驗證新密碼與確認密碼是否一致
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        await Swal.fire({
          icon: 'error',
          title: 'Password Mismatch',
          text: 'New password and confirm password do not match',
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        return;
      }

      // 驗證新密碼不能與舊密碼相同
      if (this.passwordForm.oldPassword === this.passwordForm.newPassword) {
        await Swal.fire({
          icon: 'error',
          title: 'Same Password',
          text: 'New password must be different from current password',
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        return;
      }

      // 開始提交
      this.isSubmitting = true;

      try {
        const result = await authService.updatePassword({
          oldPassword: this.passwordForm.oldPassword,
          newPassword: this.passwordForm.newPassword,
          confirmPassword: this.passwordForm.confirmPassword,
        });

        // 根據 result.data.ok 判斷成功或失敗
        if (result.success && result.data?.ok === true) {
          Swal.fire({
            icon: 'success',
            title: 'Password Updated Successfully!',
            text: result.message || 'Your password has been updated. Please login again with your new password.',
            confirmButtonColor: '#4d167d',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didClose: () => {
              // 清空表單
              this.passwordForm = {
                oldPassword: '',
                newPassword: '',
                confirmPassword: '',
              };

              // 登出並導向登入頁面
              this.logout();
              this.$router.push('/');
            }
          });
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Password Update Failed',
            text: result.message || 'Failed to update password. Please check your current password and try again.',
            confirmButtonColor: '#4d167d',
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
        }
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Unexpected Error',
          text: 'An error occurred while updating password. Please try again.',
          confirmButtonColor: '#4d167d',
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
        console.error('Error updating password:', error);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
